module.exports = __webpack_public_path__ + "MaterialIcons-Regular.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/material-design-icons/iconfont/MaterialIcons-Regular.ttf
// module id = 85
// module chunks = 0